// @ts-nocheck

import React, { type Node } from 'react';
import styled from 'styled-components';

import { KLBannerButtonBackground } from '../../assets/img/buttons';
import SharedStyle from '../../styled-component/shared';

const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  ${SharedStyle.ImageAsButtonsBehaviour}
`;

const Background = styled.img`
  object-fit: cover;
  height: 1.3em;
`;

const Label = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'BettingKalam';
  font-weight: bold;
  font-size: 0.75em;
`;

type KLButtonProps = {
  className?: string;
  onClick?: () => void;
  children: Node;
};

const KLBannerButton = ({ className, onClick, children }: KLButtonProps) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <Background src={KLBannerButtonBackground} alt="" />
      <Label>{children}</Label>
    </Wrapper>
  );
};

export default KLBannerButton;
